import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { UploadRidesDialog } from '../UploadRidesDialog.tsx';
import { showPaywall } from '../../lib/plan.ts';
import { SETUP_KEY, type SetupStatus } from '../../hooks/useSetup.ts';

/**
 * "Import history": opens the history ZIP import for Pro (``zip_import``
 * ``available``), the upgrade entry with the reason otherwise.
 */
export function HistoryImportButton({
  zipImport,
  className,
  children,
}: Readonly<{ zipImport: SetupStatus['history']['zip_import']; className: string; children: React.ReactNode }>) {
  const [open, setOpen] = useState(false);
  const qc = useQueryClient();
  const onClick = () => {
    if (zipImport === 'available') setOpen(true);
    else showPaywall('history_import');
  };
  const onClose = () => {
    setOpen(false);
    void qc.invalidateQueries({ queryKey: SETUP_KEY });
  };
  return (
    <>
      <button type="button" onClick={onClick} className={className}>
        {children}
      </button>
      {open && <UploadRidesDialog onClose={onClose} />}
    </>
  );
}
